import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './components/HomePage';
import ProductList from './components/ProductList';
import ProductPage from './components/ProductPage';
import CategoryPage from './components/CategoryPage';
import Footer from './components/Footer';
import FAQ from './components/FAQ';
import OrderSummary from './components/OrderSummary';
import { CartProvider } from './components/CartContext';
import CartPage from './components/CartPage';
import CheckoutPage from './components/CheckoutPage';
import Compliance from './components/Compliance';
import VapePensDeal from './components/VapePensDeal';
import { products } from './products';
import './App.css';

function App() {
  return (
    <CartProvider>
      <Router>
        <div className="App">
          <Compliance />
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/products" element={<ProductList products={products} />} />
              <Route path="/product/:id" element={<ProductPage />} />
              <Route path="/category/:category" element={<CategoryPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/order-summary" element={<OrderSummary />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/deals" element={<VapePensDeal />} />
              {/* 404 Fallback Route */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </CartProvider>
  );
}

// Simple 404 component for unmatched routes
const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1>404 - Page Not Found</h1>
        <p>Sorry, the page you're looking for doesn't exist.</p>
        <a href="/" className="back-home-link">Return to Home</a>
      </div>
    </div>
  );
};

export default App;